import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import Fade from "react-reveal/Fade"

const About = ({ isLangEn }) => {
  const data = useStaticQuery(graphql`
    query {
      aboutImage1: file(relativePath: { eq: "about-img1.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 660) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage2: file(relativePath: { eq: "about-img2.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 340) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage3: file(relativePath: { eq: "about-img3.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 550) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage4: file(relativePath: { eq: "about-img4.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 400) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage5: file(relativePath: { eq: "about-img5.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 550) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage6: file(relativePath: { eq: "about-img6.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 350) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage7: file(relativePath: { eq: "about-img7.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 580) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      aboutImage8: file(relativePath: { eq: "about-img8.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 300) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <div className="about__items">
        <div className="about__item about__item--1 container-wide">
          <div className="about__item__image">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage1.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={600} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    Born in Kobe, and raised by a Japanese mother and British
                    father, Ema grew up navigating between cultures. As a
                    teenager, Ema's passion was modern dance, through which she
                    learned discipline and self-expression.
                  </p>
                  <p>
                    Her interest in filmmaking began in middle school, when she
                    was given the opportunity to tell stories using a video
                    camera.
                  </p>
                  <p>
                    When she was 19, she moved to New York and attended New York
                    University's Tisch School of the Arts, focusing on
                    documentary and editing. Upon graduating from NYU, she began
                    her career as an assistant editor, mentored by documentary
                    mogul Sam Pollard.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    神戸生まれ。イギリス人の父と日本人の母を持つ。大阪の公立小学校を卒業後、中・高は神戸のインタナショナルスクールに通った。青春時代にはモダンダンスに没頭し、自己表現の面白さと難しさを学ぶ。
                  </p>
                  <p>
                    映像制作に興味を持ったのは中学生の授業でビデオカメラを使って「何か」を伝える機会をもらった時。ストーリーテラーになることに魅力を感じた。
                  </p>
                  <p>
                    19歳で渡米しニューヨーク大学映画制作学部を卒業後、巨匠サム・ポラードの編集助手としてキャリアを開始。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--2 container-narrow">
          <div className="about__item__image">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage2.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    During her first year out of film school, Ema was selected
                    through an open-call process with Al Jazeera English to make
                    MONK BY BLOOD, a 25-minute documentary about a family that
                    runs an 800-year-old temple in Kyoto.
                  </p>

                  <p>
                    In 2014, Ema was an editor on CNN's docu-series CHICAGOLAND,
                    executive produced by Robert Redford. She went on to edit
                    and co-produce CLASS DIVIDE, an HBO documentary directed by
                    Marc Levin, which won the Grand Jury Prize at DOC NYC in
                    2015.{" "}
                  </p>
                  <p>
                    In 2016, she co-directed a documentary for NHK on Martin
                    Scorsese's film SILENCE.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    2012年、大学卒業直後に応募した国際衛星テレビ局アルジャジーラの一般応募を勝ち抜き、京都で800年続くお寺を持つ家族のジレンマを捉えた『MONK
                    BY
                    BLOOD（お寺の子）』を制作。2013年に130カ国以上で放送された。
                  </p>

                  <p>
                    2014年にはロバート・レッドフォードがエグゼキュティブ・プロデュースし、巨匠マーク・レビンが監督を務めたCNN
                    のドキュメンタリーシリーズ番組『 CHICAGOLAND
                    』の編集を担当。
                  </p>
                  <p>
                    その後レビン氏と再びタッグを組み、編集とコープロデュースを手がけた長編ドキュメンタリー『CLASS
                    DIVIDE』 が2015年、DOC
                    NYCでグランプリを受賞し、2016年にHBOで放送。
                  </p>
                  <p>
                    2017年1月にNHKで放送されたマーティン・スコセッシ監督の映画『沈黙』にまつわるドキュメンタリー番組にアメリカ側のディレクターとして参加した。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>
        <div className="about__item about__item--3 container-narrow">
          <div className="about__item__image">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage3.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={300} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    In 2017, Ema's first feature length documentary, MONKEY
                    BUSINESS: THE ADVENTURES OF CURIOUS GEORGE'S CREATORS, was
                    released worldwide.
                  </p>
                  <p>
                    The documentary uses animation, archival materials and
                    interviews to tell the incredible story of Hans and Margret
                    Rey, the authors of the beloved children's book series
                    Curious George. For the film, Ema successfully raised over
                    $186,000 on Kickstarter.
                  </p>
                  <p>
                    Acquired by The Orchard, the film premiered at the LA Film
                    Festival and won the Audience Award at the Nantucket Film
                    Festival.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    監督、プロデュース、編集を手がけた初長編ドキュメンタリー作品『モンキービジネス：おさるのジョージ著者の大冒険』（英題『MONKEY
                    BUSINESS: THE ADVENTURES OF CURIOUS GEORGE'S
                    CREATORS』）では、人気絵本シリーズ「おさるのジョージ」の著作者、ハンスとマーガレット・レイ夫妻の半生をアニメーション、アーカイブ映像、インタビューを交えて描いた。
                  </p>
                  <p>
                    3年間の制作期間を経て主に大学時代の仲間と作り上げた作品は、クラウドファンデングで18万6000ドル（約2000万円）を集め、2017年にロサンゼルス映画祭でワールドプレミア後、アメリカの大手配給会社オーチャードから世界配給。日本での劇場公開は2018年夏より行われた。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--4 container-narrow">
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    Having lived in New York for 9 years, Ema developed a new
                    perspective toward her homeland of Japan, gaining an
                    appreciation for the core values that had shaped her own
                    character.
                  </p>
                  <p>
                    With a desire to tell more complex stories about Japan than
                    what is typically available in international media, Ema
                    decided to create a base in Tokyo from the spring of 2017.
                  </p>
                  <p>
                    In 2018, Ema embarked on her second feature documentary
                    KOSHIEN: JAPAN'S FIELD OF DREAMS, exploring the cultural
                    phenomenon of Japanese high school baseball as a microcosm
                    of Japanese society.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    2008年より9年間ニューヨークに住んでいた山崎は、日本を出たからこそ気づいた日本独特の良さ、そして「アニメ・スシ・フクシマ」以外の日本の姿を海外に発信したいという思いが強くなり、2017年春から東京にも拠点を作った。
                  </p>
                  <p>
                    その夏、久しぶりに目にした高校野球の姿が、日本社会の規律や協調性の象徴に見え、次回作のテーマにすることを決める。夏の甲子園100回大会を迎えた高校野球の長期取材はNHK・NHKエンタープライズとの国際共同制作プロジェクトとなり、NHKでは2018年夏にノーナレ『遥かなる甲子園~Diaries
                    of
                    Youth~』が、そして2019年春にETV特集『HOME〜我が愛しの甲子園〜』が放送。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--5 container-narrow intersection">
          <div className="about__item__image">
            <Fade bottom delay={600} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage5.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    In co-production with NHK, the film is an intimate and
                    dramatic journey following coaches and players from two high
                    schools - one being Shohei Ohtani's alma mater - during the
                    historic 100th summer Koshien tournament. Koshien examines
                    the past, present, and future of Japan's national obsession,
                    as it struggles to balance character building traditions
                    with more moderate ways to educate the next generation of
                    successful adults. After premiering at DOC NYC, the film
                    aired in primetime on ESPN in 2020, and was released
                    theatrically in Japan. It became a New York Times
                    recommendation for international streaming and featured on
                    the Criterion Channel.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    海外向けの映画完全版『KOSHIEN: Japan's Field of
                    Dreams』は2019年にアメリカ最高峰のドキュメンタリー映画祭DOC
                    NYCでワールドプレミアされ、2020年6月にはスポーツ・チャンネルESPNにて全米放送。ニューヨークタイムズ紙の「海外映画おすすめトップ５」にも選出された。
                  </p>
                  <p>
                    日本では戦後初めて甲子園が中止された2020年夏、劇場公開。大谷翔平と菊池雄星を輩出した花巻東高校の佐々木監督と、その彼が師と仰ぐ横浜隼人高校の水谷監督のそれぞれの100回大会の年を通して、戦後からの日本、そしてこれからの日本を見つめる作品となった。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--6 container">
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    Also in 2019, Ema directed a 47-part mini-documentary series
                    for NHK that aired in tandem with its annual historical
                    “Taiga” drama, IDATEN, featuring stories about the history
                    of Japan, sports, and its Olympic quest.
                  </p>
                  <p>
                    Additionally, her 11-part short documentary series about
                    baseball player Ichiro Suzuki, “#dearICHIRO”, was
                    commissioned by Yahoo! Japan.
                  </p>
                  <p>
                    In 2020, Ema completed her 5-year long project on the
                    renowned Alvin Ailey American Dance Theatre's long-time
                    Japanese Associate Artistic Director, Masazumi Chaya, CHAYA:
                    AILEY'S KEEPER OF THE FLAME. The documentary follows Chaya's
                    final years before retirement, while reflecting on his life
                    as a Japanese pioneer in the world of dance. It aired on NHK
                    and NHK World.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    2019年にはNHK大河ドラマ『いだてん』の紀行番組（全47本）を担当。『#dearICHIRO』（全11本、Yahoo!
                    Japan Creators
                    Programで配信）では、子供の頃からの自身のヒーローであるイチロー選手が、世の中に与えた影響を探りながらファンや関係者の物語を取り上げた。
                  </p>

                  <p>
                    2020年には、世界屈指の舞踊団アルビン・エイリー・アメリカン・ダンス・シアターの副芸術監督を30年近く務めた日本人、茶谷正純を5年間追った『CHAYA
                    魂の番人〜エイリー舞踊団に捧げた半生〜』がNHK
                    BS1スペシャルとして放送。NHKワールドでも放映された。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--7 container-narrow">
          <div className="about__item__image">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage6.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={600} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    Ema also directed WHEELS OF FATE: THE STORY OF THE RICKSHAW
                    MAN, exploring the fateful history of Japan's singular
                    humanist film made during World War II. The short
                    documentary premiered together with the 4K restoration of
                    THE RICKSHAW MAN in the Venice Film Festival's Classics
                    section.
                  </p>
                  <p>
                    In December 2020, Ema received the "Documentary Filmmaker of
                    the Year Award" from Yahoo! JAPAN.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    第二次世界大戦中に製作された日本の特異なヒューマニズム映画の運命的な歴史を探求する『ウィール・オブ・フェイト～映画「無法松の一生」をめぐる数奇な運命～』を監督。本短編ドキュメンタリーは、『無法松の一生』の4K修復版とともにヴェネチア国際映画祭のクラシック部門でプレミア上映された。
                  </p>
                  <p>
                    2020年12月、Yahoo! JAPANの「Documentary Filmmaker of the
                    Year Award」を受賞。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--8 container-narrow">
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    In 2021, TEMPLE FAMILY, following the future head priest of
                    a 800-year-old temple family in Kyoto, his fiancée, and his
                    sister, aired on NHK and NHK World. The film captures one
                    unexpected corner of Japanese society's struggle to balance
                    tradition with progress, especially on the top of gender. It
                    is a sequel to MONK BY BLOOD.
                  </p>
                  <p>
                    Ema also joined Naomi Kawase's team as Co-Director and
                    Supervising Editor of the official Olympic film “The Olympic
                    Games Tokyo 2020”, which premiered at the Cannes Film
                    Festival in 2022.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    2021年には京都にある800年の歴史を持つ寺の未来の住職とその婚約者、そして姉を追った『TEMPLE
                    FAMILY』がNHKとNHKワールドで放映された。本作品は、伝統と進歩のバランス、特にジェンダーに関しての課題で奮闘する日本社会の意外な一面を捉えている。『MONK
                    BY BLOOD』の続編でもある。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--9 container-narrow intersection">
          <div className="about__item__image">
            <Fade bottom delay={600} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage7.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    Ema's latest feature THE MAKING OF A JAPANESE made its world
                    premiere at the Tokyo International Film Festival in 2023.
                    With unprecedented access to a public elementary school in
                    Tokyo, the film intimately follows 1st and 6th graders for
                    one year, observing kids learning the traits necessary to
                    become part of Japanese society. Having attended Japanese
                    elementary school herself, the film comes from Ema's belief
                    that the foundation of Japanese society can be seen in the
                    schooling system. The film is represented by renowned sales
                    agent Autlook, with the international premiere at
                    Thessaloniki International Documentary Festival.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    2022年にはカンヌ国際映画祭でプレミア上映されたオリンピック公式映画『東京2020オリンピック』の共同監督兼スーパーバイジング・エディターとして、河瀬直美監督のチームに加わった。
                  </p>
                  <p>
                    山崎の最新作『小学校〜それは小さな社会〜』は、2023年の東京国際映画祭でワールドプレミア上映された。東京都の公立小学校に前代未聞の密着取材を敢行し、小学1年生と6年生に1年間密着し、日本社会に必要な素養を身につける子どもたちの姿を観察した。自らも日本の小学校に通った監督の「日本社会の基礎は学校教育にある」という信念から生まれた作品である。
                  </p>
                  <p>
                    本作品は、業界を代表する海外セールス社Autlookによって販売され、テッサロニキ国際ドキュメンタリー映画祭でのインターナショナルプレミア上映。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>

        <div className="about__item about__item--10 container-narrow intersection">
          <div className="about__item__image">
            <Fade bottom delay={600} duration={800} distance={"20px"}>
              <Img fluid={data.aboutImage8.childImageSharp.fluid} />
            </Fade>
          </div>
          <div className="about__item__text">
            <Fade bottom delay={200} duration={800} distance={"20px"}>
              {isLangEn ? (
                <div>
                  <p>
                    Most recently Ema was Editor and Co-Producer on Shiori Ito's
                    BLACK BOX DIARIES, which world premiered at the Sundance
                    Film Festival's World Documentary Competition in 2024 to
                    critical acclaim. The Screen Daily called Ema's work
                    “brilliant” and Variety commented on how “[the] material is
                    all expertly braided by editor Ema Ryan Yamazaki”. The film
                    is undergoing a film festival run, including MoMa's Doc
                    Fortnight, SXSW, CPH:DOX, and Hong Kong International Film
                    Festival. She has also been serving as an Executive Producer
                    on director Neo Sora's debut narrative feature film.
                  </p>
                  <p>
                    Ema married film producer Eric Nyari in 2017, and they
                    frequently collaborate as producing/directing partners. They
                    have a son, born in 2022.
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    最近では、伊藤詩織監督の『BLACK BOX
                    DIARIES』の編集とコープロデューサーを務め、2024年のサンダンス映画祭ワールド・ドキュメンタリー・コンペティション部門でワールドプレミア上映され、高い評価を得た。スクリーン・デイリー誌は山崎の編集を「素晴らしい」と評し、ヴァラエティ誌は「編集者の山崎エマによって、すべての素材が巧みに編み込まれている」とコメントした。本作品は、MoMA（ニューヨーク近代美術館）のDoc
                    Fortnight、SXSW（サウス・バイ・サウスウエスト映画祭）、CPH:DOX（デンマーク）、香港国際映画祭などの映画祭に出品中。
                  </p>
                  <p>
                    また、空音央監督の長編劇映画デビュー作では、エグゼキュティブ・プロデューサーを務めている。
                  </p>
                  <p>
                    2017年には映画プロデューサーのエリック・ニアリと結婚。監督とプロデューサーのパートナーシップを組んで作品に取り組む機会も多い。2022年には二人の間に息子が誕生。
                  </p>
                </div>
              )}
            </Fade>
          </div>
        </div>
      </div>

      <section className="parallax parallax-bicycle"></section>
    </>
  )
}

export default About
